import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.css'],
})
export class PrivacyPolicyComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/privacy-policy/privacy-policy.component.ts